module.exports = __webpack_public_path__ + "img/h02-min.bee4c4f7.png";